import { motion } from "framer-motion";
import { Heart, Check } from "lucide-react";
import { waLink } from "../../data/site";
import { Reveal } from "./Reveal";

const BENEFITS = [
  "Cobertura para toda a família em um único plano",
  "Opções de pessoa física familiar e por adesão",
  "Análise de rede e faixa de preço ideal para o seu grupo",
];

export const Family = () => (
  <section id="familia" data-testid="family-section" className="bg-paper px-4 py-10 sm:px-6 lg:px-8">
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#26324A] px-6 py-16 sm:px-12 sm:py-20">
        <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-champagne/10 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/5 blur-2xl" />

        <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="order-2 lg:order-1">
            <div className="relative mx-auto w-full max-w-md">
              <motion.div
                animate={{ y: [0, -12, 0] }}
                transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
                className="relative overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl shadow-black/40"
              >
                <img
                  src="/assets/ilustra-familia.png"
                  alt="Ilustração de uma família: pai, mãe e dois filhos de mãos dadas"
                  data-testid="family-illustration"
                  className="aspect-[16/10] w-full object-cover"
                />
              </motion.div>
              <motion.span
                animate={{ y: [0, -8, 0], opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -right-3 top-8 h-4 w-4 rounded-full bg-champagne/60"
              />
              <motion.span
                animate={{ y: [0, 10, 0], opacity: [0.4, 0.9, 0.4] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                className="absolute -left-2 bottom-12 h-3 w-3 rounded-full bg-wa/50"
              />
            </div>
          </div>

          <div className="order-1 text-center lg:order-2 lg:text-left">
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-surface text-champagne-dark shadow-sm">
              <Heart className="h-7 w-7" strokeWidth={1.8} />
            </span>
            <p className="mt-6 font-mono text-xs font-semibold uppercase tracking-[0.24em] text-champagne-dark">
              Planos para a família
            </p>
            <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.15]">
              Um plano para proteger{" "}
              <em className="italic text-champagne-dark">quem você mais ama.</em>
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-stone-400 lg:max-w-none">
              Opções de planos familiares — pessoa física com dependentes ou
              adesão — com análise do seu grupo familiar para apresentar a
              alternativa adequada ao seu perfil.
            </p>
            <ul className="mt-7 inline-flex flex-col gap-3.5 text-left">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-champagne/20">
                    <Check className="h-3 w-3 text-champagne-dark" strokeWidth={3} />
                  </span>
                  <span className="text-sm leading-relaxed text-stone-300">{b}</span>
                </li>
              ))}
            </ul>
            <div>
              <a
                href={waLink("Olá! Gostaria de conhecer as opções de plano de saúde para minha família.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="family-cta"
                className="mt-9 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-brand-dark"
              >
                Conhecer as opções para minha família
              </a>
            </div>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
